import React from 'react'
import IProps from './props'
import TranslationHelper from '../../helpers/helper-translation'

const AvailabilitySchedule = ({ availability }: IProps) => (
  <div>
    {Object.entries(availability).map(([day, schedule]) => {
      const {
        selected, morning, afternoon, night,
      } = schedule

      if (selected && (morning || afternoon || night)) {
        const availableSchedules = []

        if (morning) availableSchedules.push('Manhã')
        if (afternoon) availableSchedules.push('Tarde')
        if (night) availableSchedules.push('Noite')

        const scheduleString = `${TranslationHelper.translateDay(day)}: ${availableSchedules.join(', ')}.`

        return <div key={`availability-${day}`}>{scheduleString}</div>
      }

      return null
    })}
  </div>
)

export default AvailabilitySchedule
